import React from 'react';
import { Link } from 'react-router-dom';
import { Colors, Text } from 'library';
import { Provider } from 'models';
import useGoToProfile from './actions/goToProfile';

const ProviderCardName = ({
    provider,
    mobile = false,
    onGoToProfileClick,
    jobId,
}: {
    provider: Provider;
    mobile?: boolean;
    onGoToProfileClick?: () => void;
    jobId?: number;
}) => {
    const { getProfilePath, onGoToProfileLinkClicked } = useGoToProfile();

    return (
        <Link
            to={getProfilePath(provider, jobId)}
            onClick={() => {
                onGoToProfileLinkClicked(provider, 'Provider Card Click', onGoToProfileClick);
            }}
            style={{ color: Colors.darkNavy, textDecoration: 'underline' }}
        >
            <Text
                variant="display"
                textStyle={{
                    fontSize: mobile ? 26 : 32,
                    maxWidth: '100%',
                    fontWeight: 900,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    lineHeight: '36px',
                }}
            >
                {provider.user.first_name} {provider.user.last_name}
            </Text>
        </Link>
    );
};

export default ProviderCardName;
